/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 15:13:50
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/ProductList.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   ProductListDisplay,
  //ProductList,

  ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const ProductListDisplayFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnSubscriptionStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnProductListItemReselect = (id, products) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: products });
    }
  };

  const handleOnProductListItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnProductListItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: { from, to },
      });
    }
  };

  const handleOnProductListItemDeleteAll = (id) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.deleteAll,
        id,
        data: [],
      });
    }
  };
  const handleOnCarouselModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  return {
    handleOnProductListItemReselect,
    handleOnProductListItemDelete,
    handleOnProductListItemSort,
    handleOnProductListItemDeleteAll,
    handleOnCarouselModuleTypeChange,
    handleOnSubscriptionStaticChange,
    //  handleOnProductListDisplayModuleTypeChange,
  };
};
const generateProductListDisplay = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  allDisabled,
}) => {
  const {
    handleOnProductListItemReselect,
    handleOnProductListItemDelete,
    handleOnProductListItemSort,
    handleOnProductListItemDeleteAll,
    handleOnCarouselModuleTypeChange,
    handleOnSubscriptionStaticChange,
  } = ProductListDisplayFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ListAdaptor,
    props: {
      onItemReselect: handleOnProductListItemReselect,
      onItemDelete: handleOnProductListItemDelete,
      onItemSort: handleOnProductListItemSort,
      onItemDeleteAll: handleOnProductListItemDeleteAll,
      onModuleTypeChange: handleOnCarouselModuleTypeChange,
      onStaticChange: handleOnSubscriptionStaticChange, //
      allDisabled,
    },
  };
};
export { generateProductListDisplay };
